import { capitalizeFirstLetter } from "utils/misc";
import { HealthFormType, MarketCode } from "routes/createContent/api/templateDtos";

// Option lists for the template editor selects. Mirror the v2 enums in
// physio-app-reactjs's Treatment schemas.
export const HEALTH_FORM_TYPE_OPTIONS: HealthFormType[] = [
  "fall_prevention",
  "generic",
  "generic_other_ailment",
  "hand_oa",
  "hip_oa",
  "knee_oa",
  "low_back_pain",
  "neck",
  "osteoporosis",
  "shoulder_pain",
];

export const MARKET_OPTIONS: { code: MarketCode; name: string }[] = [
  { code: "SE", name: "Sweden" },
  { code: "GB", name: "United Kingdom" },
  { code: "US", name: "United States" },
];

export const EXERCISES_PER_DAY_OPTIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
export const MAX_DURATION_WEEKS = 52;

export const DEFAULT_SETS = 1;
export const DEFAULT_REPS = "15";
export const MAX_SETS = 10;

// "low_back_pain" -> "Low back pain"
export const humanize = (value: string): string => capitalizeFirstLetter(value.replace(/_/g, " "));
